<div class="container" #container>
  <!-- O Custom Element <app-component> será inserido aqui -->
</div>

<!-- Botão para fechar manualmente (opcional, apenas para teste) -->
<!-- <button (click)="closeService({ message: 'Fechamento manual.' })">Fechar Manualmente</button> -->
